/* eslint-disable @angular-eslint/directive-selector */
/* tslint:disable */
import { Directive, forwardRef } from '@angular/core';
import { AbstractControl, FormControl, NG_VALIDATORS, Validator, ValidatorFn } from '@angular/forms';

function sumDigits(value: string): number {
	return value.split('').reduce((sum, char) => sum + Number(char), 0);
}

function check_tcno(a) {
	if (a.substr(0, 1) === 0 || a.length !== 11) {
		return false;
	}

	let i = 9,
		md = '',
		mc = '',
		digit,
		mr = '';

	while ((digit = a.charAt(--i))) {
		i % 2 === 0 ? (md += digit) : (mc += digit);
	}

	if ((sumDigits(md) * 7 - sumDigits(mc)) % 10 !== parseInt(a.substr(9, 1), 10)) {
		return false;
	}

	for (let c = 0; c <= 9; c++) {
		mr += a.charAt(c);
	}

	if (sumDigits(mr) % 10 !== parseInt(a.substr(10, 1), 10)) {
		return false;
	}

	return true;
}

function identificationMatcher(): ValidatorFn {
	return (c: AbstractControl) => {
		if (!c.value) {
			return null;
		}

		const isValid = check_tcno(c.value);

		if (isValid) {
			return null;
		} else {
			return {
				identificationMatcher: {
					valid: false,
				},
			};
		}
	};
}

@Directive({
	selector: '[identificationMatcher]',
	providers: [{ provide: NG_VALIDATORS, useExisting: forwardRef(() => IdentificationNoControlDirective), multi: true }],
	standalone: false,
})
export class IdentificationNoControlDirective implements Validator {
	validator: ValidatorFn;

	constructor() {
		this.validator = identificationMatcher();
	}

	validate(c: FormControl) {
		return this.validator(c);
	}
}
